var NullBounds = (function () {
    function NullBounds() {
    }
    return NullBounds;
}());
export { NullBounds };
